import ErrorBox from '@components/open-position/ErrorBox';
import styled from 'styled-components';
import { DescriptionText } from '../Modal/Modal.styles';

export const TableWrapper = styled.div`
  table {
    width: 100%;
  }
  th,
  td {
    text-align: left;
    width: 16%;
    padding: 1rem 0;
  }
  th:last-child,
  td:last-child {
    text-align: left;
    width: 20%;
  }
`;

export const ActionsWrapper = styled.div`
  padding-top: 6rem;
  display: flex;
  width: fit-content;
  margin: 0 auto;
  justify-content: space-between;
  a,
  button {
    margin: 0 20px;
  }
`;

export const StyledErrorBox = styled(ErrorBox)`
  margin-bottom: 64px;
  height: 40px;
  max-width: none;
  padding: 5px 25px 5px 5px;
  margin-top: 12px;
`;

export const StyledDescriptionText = styled(DescriptionText)<{ removeMargin?: boolean }>`
  ${({ removeMargin }) => removeMargin && `margin-bottom: 0px;`}

  strong {
    font-weight: 700;
  }
`;
